export default __webpack_public_path__ + "static/media/milestone 750.f780edc6.svg";